module.exports = __webpack_public_path__ + "static/media/germany.d810f621.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Flags/germany.svg
// module id = 243
// module chunks = 0